<template>
  <div class="accum-reward" :class="cssType">
    <!-- <p>累计充值：{{ globalConf.totalRechargeDiamondCount }} 彩钻</p> -->
     <div class="list">
      <div class="item" v-for="item in globalConf.accumulateRechargeConfigList" :key="item.rewardCode">
        <div class="item-title">{{ $t('poolParty.accumReward.itemTitle') }}</div>
        <div class="item-desc" :class="locale">{{ $t('poolParty.accumReward.itemCountText', { current: formatNumber(globalConf.totalRechargeDiamondCount), need: formatNumber(item.needRechargeDiamondCount) }) }}</div>
        <div class="item-prop-icon" :class="item.rewardCode + ' ' + locale">
          <img src="~@/assets/imgs/act/poolParty/baoxiang.png" alt="box" />
        </div>
        <div class="item-prop-name" :class="locale">{{ $t('poolParty.accumReward.randomPropNotOwned') }} * 1</div>
        <PPButton class="btn" v-if="item.status === 1" type="green" @click="receiveAllRewards">
          {{ $t('poolParty.btnCanReceive') }}
        </PPButton>
        <PPButton class="btn" v-else-if="item.status === 2" type="gray" disabled>
          {{ $t('poolParty.btnReceived') }}
        </PPButton>
        <PPButton class="btn" v-else type="blue" @click="goRecharge">
          {{ $t('poolParty.goRecharge') }}
        </PPButton>
      </div>
     </div>
     <RewardDialog v-model="rewardDialogVisible" :prop-list="propList" :title="$t('accum.rewardsAllDialog.title')" />
  </div>
</template>

<script setup>
import { inject, ref } from 'vue'
import PoolPartyActApi from '@/config/poolPartyActApi'
import { formatPropList } from '../../utils/receiveReward'
import { isMobile } from '@/utils'
import PPButton from '../PPButton/index.vue'
import RewardDialog from '../Dialog/RewardDialog/index.vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useLog } from '@/composables/useLog'
const log = useLog()
const {locale} = useI18n()
// 数字转换成千位符
const formatNumber = (number) => {
  if (locale.value === 'hk' || locale.value === 'tw') {
    return number
  }
  return number.toLocaleString()
}
const cssType = isMobile ? 'mobile' : 'pc'
const globalConf = inject('globalConf')
const refreshUserDetail = inject('refreshUserDetail')
const router = useRouter()
const rewardDialogVisible = ref(false)
const propList = ref([])
const receiveAllRewards = async () => {
  const res = await PoolPartyActApi.receiveAllRewards()
  const result = formatPropList(res, globalConf.value.dailyRewardConfigList)
  propList.value = result
  rewardDialogVisible.value = true
  try {
    log.track('act_pp_receive_accum_rewards', { v1: res.dailyDayIndexList.join(','), v2: res.accumulateRewardCodeList.join(','), v3: res.activityPropList.map(item => item.propId).join(',') })
  } catch(error) {
    console.error(error)
  }
  await refreshUserDetail()
}

const goRecharge = () => {
  log.track('act_pp_recharge')
  const resolved = router.resolve({ name: 'Payment' })
  window.open(resolved.href, '_blank')
}
</script>

<style scoped lang='less' src='./pc_style.less'></style>
<style scoped lang='less' src='./mobile_style.less'></style>
